import { get } from "../../utils/httpClient";

const tagService = () => {
  const prefixApi = "duedates/tags";

  const getTags = async () => {
    return await get(`/${prefixApi}`);
  };

  return {
    getTags,
  };
};

export default tagService;
